var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 14,
    viewBox: "0 0 26 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 0.75H15.5C14.8125 0.75 14.25 1.3125 14.25 2C14.25 2.6875 14.8125 3.25 15.5 3.25H19.25C21.3125 3.25 23 4.9375 23 7C23 9.0625 21.3125 10.75 19.25 10.75H15.5C14.8125 10.75 14.25 11.3125 14.25 12C14.25 12.6875 14.8125 13.25 15.5 13.25H19.25C22.7 13.25 25.5 10.45 25.5 7C25.5 3.55 22.7 0.75 19.25 0.75ZM8 7C8 7.6875 8.5625 8.25 9.25 8.25H16.75C17.4375 8.25 18 7.6875 18 7C18 6.3125 17.4375 5.75 16.75 5.75H9.25C8.5625 5.75 8 6.3125 8 7ZM10.5 10.75H6.75C4.6875 10.75 3 9.0625 3 7C3 4.9375 4.6875 3.25 6.75 3.25H10.5C11.1875 3.25 11.75 2.6875 11.75 2C11.75 1.3125 11.1875 0.75 10.5 0.75H6.75C3.3 0.75 0.5 3.55 0.5 7C0.5 10.45 3.3 13.25 6.75 13.25H10.5C11.1875 13.25 11.75 12.6875 11.75 12C11.75 11.3125 11.1875 10.75 10.5 10.75Z",
    fill: "#757575"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.912d9696e0e087e80ad50eb3efe8bdf1.svg";
export { ForwardRef as ReactComponent };